export const DEMO = {
  company: "Summit Ridge Roofing",
  homeowner: "Sarah Mitchell",
  phone: "(555) 010-2231",
  address: "4127 Birchwood Lane, Springfield (fictional)",
  issue: "Roof leak over the kitchen after last night's storm",
  roof: "Asphalt shingle, about 15 years old",
  urgency: "High: active drip",
  value: "$8,500 (estimated)",
  email: "sarah.mitchell@example.com",
  estimator: "Mike (Summit Ridge estimator)",
  slot: "Thursday, 10:00 AM",
};

export const IVR_SCRIPT =
  `Thanks for calling ${DEMO.company}. We can't get to the phone right now. If you'd like ${DEMO.company} to text you about your roofing request, press 1. ` +
  "Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help. To decline, press 2.";

export const SMS = [
  ["ai", `${DEMO.company}: Hi, this is ${DEMO.company}'s virtual assistant. Sorry we missed your call! What's going on with your roof? Reply STOP to opt out.`],
  ["home", "Hi, water is dripping from the kitchen ceiling since the storm last night."],
  ["ai", "I'm sorry, that sounds stressful. Is it dripping right now, and roughly how old is the roof?"],
  ["home", "Yes, slowly. It's shingles, maybe 15 years old."],
  ["ai", "Thanks. What's the property address so our estimator can take a look?"],
  ["home", "4127 Birchwood Lane, Springfield"],
  ["ai", "Got it. And what's the best name and email for your estimate details?"],
  ["home", "Sarah Mitchell, sarah.mitchell@example.com"],
  ["sim", "Simulated: booking by text. Shown for illustration; not currently active."],
  ["ai", "Thanks, Sarah! I can book your free estimate. Which works better?\n1) Thursday 10:00 AM\n2) Friday 1:00 PM"],
  ["home", "1"],
  ["ai", `You're booked! Free roof estimate Thursday at 10:00 AM at 4127 Birchwood Lane from ${DEMO.company}. Reply C to change.`],
];

export const STEPS = [
  { key: "call", title: "Incoming call", say: "A homeowner calls about a roof leak." },
  { key: "missed", title: "Missed call", say: "The crew is on a roof and can't answer. RoofLead picks up the missed call." },
  { key: "consent", title: "Text consent", say: "An automated message offers a text follow-up. The homeowner presses 1." },
  { key: "sms", title: "AI text conversation", say: "The AI assistant replies in the roofer's name, collects the details and (simulated) offers times to book." },
  { key: "lead", title: "New lead in RoofLead", say: "Everything collected lands in the dashboard, including the appointment." },
  { key: "alert", title: "Team is alerted", say: "The roofer gets an instant email alert with the lead and appointment details." },
  { key: "calendar", title: "Appointment on the calendar", say: "The appointment Sarah picked appears on the team's calendar, in an open slot." },
  { key: "done", title: "Estimate booked", say: "The lead moves to Estimate Booked. Nothing slipped through the cracks." },
];
